import { IResortPathInfo, IWeatherInfo, ResortWeatherLocation } from 'api/resort/types';
import { Daily } from 'components/resort/ResortWeather/Daily';
import { Hourly } from 'components/resort/ResortWeather/Hourly';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { useCallback, useState } from 'react';
import { useAnalytics } from 'util/analytics';
import { DistanceUnit } from 'components/blocks/Unit';
import { RegularAd } from 'googlead/components/RegularAd';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { BlockHeader } from 'components/blocks/BlockHeader';
import styles from './styles.module.scss';

export const ResortWeather = (
  {
    weatherInfoDaily,
    weatherInfoHourly,
  }: {
    weatherInfoDaily: IWeatherInfo,
    weatherInfoHourly: IWeatherInfo,
    pathInfo: IResortPathInfo
  },
) => {
  const hasBase = weatherInfoDaily.weatherItems && weatherInfoDaily.weatherItems.length > 0 && weatherInfoDaily.weatherItems[0].base;
  const hasSummit = weatherInfoDaily.weatherItems && weatherInfoDaily.weatherItems.length > 0 && weatherInfoDaily.weatherItems[0].summit;

  const [activeTab, setActiveTab] = useState(hasBase ? ResortWeatherLocation.base : ResortWeatherLocation.summit);
  const { t } = useOTSTranslation('common');

  const a = useAnalytics();

  const setBase = useCallback(() => {
    /* a.viewContent({
      content: 'Hourly Weather Forecast',
    }); */
    setActiveTab(ResortWeatherLocation.base);
  }, [a, setActiveTab]);

  const setSummit = useCallback(() => {
    a.viewContent({
      content: 'Hourly Weather Forecast',
    });
    setActiveTab(ResortWeatherLocation.summit);
  }, [a, setActiveTab]);

  return (
    <div className={styles.wrap}>
      <div className={styles.tabs}>
        {hasBase && (
          <>
            <button
              type="button"
              className={activeTab === ResortWeatherLocation.base ? styles.active : ''}
              onClick={setBase}
            >
              {t('common.base')}
              <span className={styles.elevation}>
                (
                <DistanceUnit values={weatherInfoDaily.base} type="mOrFeetShort" />
                )
              </span>
            </button>

          </>
        )}
        {hasSummit && (
          <>
            <button
              type="button"
              className={activeTab === ResortWeatherLocation.summit ? styles.active : ''}
              onClick={setSummit}
            >
              {t('common.summit')}
              <span className={styles.elevation}>
                (
                <DistanceUnit values={weatherInfoDaily.summit} type="mOrFeetShort" formatAll />
                )
              </span>
            </button>

          </>
        )}
      </div>
      <div>
        <Daily weatherDaily={weatherInfoDaily} weatherLocation={activeTab} />
        <RegularAd isFirst />

        <BoxWithShadow>
          <BlockHeader title={t('resort.weather.hourly')} />
          <Hourly weatherHourly={weatherInfoHourly} weatherLocation={activeTab} />
        </BoxWithShadow>

      </div>
    </div>
  );
};
